/* @flow */
import ActivityRecipient from 'entities/ActivityRecipient';
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Menu from 'components/Menu.jsx';
import MenuItem from 'components/MenuItem.jsx';
import React from 'react';
import { capitalize } from 'lodash';

import './styles/RSVPDropdown.scss';

type Props = {
  onRSVPChange: () => void,
  activityRecipient: ?ActivityRecipient,
};

class RSVPDropdown extends React.Component {
  props: Props;

  onRSVPYes = () => {
    this.props.onRSVPChange('yes');
  }

  onRSVPNo = () => {
    this.props.onRSVPChange('no');
  }

  onRSVPMaybe = () => {
    this.props.onRSVPChange('maybe');
  }

  renderMenu() {
    return (
      <Menu>
        <MenuItem onClick={this.onRSVPYes}>
          Yes
        </MenuItem>
        <MenuItem onClick={this.onRSVPMaybe}>
          Maybe
        </MenuItem>
        <MenuItem onClick={this.onRSVPNo}>
          No
        </MenuItem>
      </Menu>
    );
  }

  render() {
    const { activityRecipient } = this.props;
    const attendance = activityRecipient ?
      activityRecipient.getAttendance() :
      'pending';

    return (
      <div className="RSVPDropdown">
        <LayerTrigger
          layer={this.renderMenu()}
          trigger="click"
          alignment="right"
          placement="bottom">
          <Button
            size="xsmall"
            level="secondary">
            <span>
              {attendance === 'pending' ? 'RSVP' : capitalize(attendance)}
            </span>
            <Glyph name="chevron-down" />
          </Button>
        </LayerTrigger>
      </div>
    );
  }
}

export default RSVPDropdown;



// WEBPACK FOOTER //
// ./src/payments/components/RSVPDropdown.jsx